import dynamic from 'next/dynamic';
import { PlayerNews } from 'services/players';
import { useEffect, useState } from 'react';
import { Divider } from 'core/generic/elements/divider';
import styles from './news-list.module.scss';
import { useAppTranslation } from 'hooks/use-translates';

const NewsCard = dynamic(() => import('core/generic/components/cards/card-news'));

type NewsListProps = {
    firstName?: string;
    lastName?: string;
    news: PlayerNews['items'];
};

export const NewsList = ({ firstName, lastName, news }: NewsListProps) => {
    const [direction, setDirection] = useState<'Row' | 'Column'>(
        typeof window !== 'undefined' && window.innerWidth > 600 ? 'Column' : 'Row',
    );
    const [size, setSize] = useState<'Small' | 'Large'>(
        typeof window !== 'undefined' && window.innerWidth > 1024 ? 'Large' : 'Small',
    );
    const { t } = useAppTranslation();

    useEffect(() => {
        const handleResize = () => {
            setDirection(window.innerWidth > 600 ? 'Column' : 'Row');
            setSize(window.innerWidth > 1024 ? 'Large' : 'Small');
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={`container ${styles['news-list']}`}>
            <h2 className={`display-large bold ${styles['title']}`}>
                {t('players_profile.heading_all_news', undefined, `All news`)}: {firstName} {lastName}
            </h2>
            <div className="row">
                {news.map((item, index) => (
                    <div className="col-12 col-sm-4 col-lg-3" key={index + 'news-card'}>
                        <NewsCard data={item} size={size} direction={direction} />
                        {index !== news.length - 1 && (
                            <div className={styles['divider-wrapper']}>
                                <Divider />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
